import React, { useState, useEffect } from 'react';
import Card from '../../../components/common/Card';
import logo1 from "../../../assets/dashboard/dot.png"
import logo2 from "../../../assets/dashboard/soldproducts.png"

import totalCoursesIcon from '../../../assets/dashboard/totalcourses-icon.png';
import userIcon from '../../../assets/dashboard/user-icon.png';
import blue from '../../../assets/dashboard/blue.png';
import green from '../../../assets/dashboard/green.png';
import trainerhatIcon from '../../../assets/dashboard/trainer-hat-icon.png';

import './CourseTable.css';
import { toast } from 'react-toastify';
import CourseTable from './CourseTable';
import CourseDetails from './CourseDetails';
import { assignStaff, deleteCourse, getAllCourses, getAllStaff } from '../../../services/Trainer/trainer';
import { acceptPolicy, acceptTrainerByAdmin, acceptUserByAdmin, declinePolicy, declineTrainerByAdmin, deleteTrainerByAdmin, deleteUserByAdmin, getAllPolicies, getAllStaffManagement, getAllTrainerManagement } from '../../../services/Admin/admin';
import NotificationsDropdown from '../../../components/common/notifications-dropdown';

const dummyCourses = [
  {
    id: 1,
    title: "Introduction to React",
    viewed: false,
    uploadDate: "2023-01-15"
  },
  {
    id: 2,
    title: "Advanced JavaScript Concepts",
    viewed: false,
    uploadDate: "2023-02-20"
  },
  {
    id: 3,
    title: "Web Design Fundamentals",
    viewed: false,
    uploadDate: "2023-03-10"
  }
];

const dashboardData = [
  {
    title: "Products Sold",
    logo1: logo1,
    logo2: logo2
  },
  {
    title: "Products Sold",
    logo1: logo1,
    logo2: logo2
  },
  {
    title: "Products Sold",
    logo1: logo1,
    logo2: logo2
  },

]
const dummyData = [
  {
    _id: "1a2b3c4d",
    name: "John Doe",
    email: "john.doe@example.com",
    phone: "+61 789654123",
    regDate: "25/09/24",
    status: "Pending",
  },
  {
    _id: "5e6f7g8h",
    name: "Jane Smith",
    email: "jane.smith@example.com",
    phone: "+61 456789123",
    regDate: "26/09/24",
    status: "Approved",
  },
  {
    _id: "9i0j1k2l",
    name: "Michael Lee",
    email: "michael.lee@example.com",
    phone: "+61 321654987",
    regDate: "24/09/24",
    status: "Rejected",
  },
  {
    _id: "3m4n5o6p",
    name: "Emily Davis",
    email: "emily.davis@example.com",
    phone: "+61 654789321",
    regDate: "23/09/24",
    status: "Pending",
  },
];
const TrainerManagement = () => {

const [courses, setCourses] = useState(dummyCourses);
const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
const [addedCourse, setAddedCourse] = useState(null);
const [showDeclineTrainerModal, setShowDeclineTrainerModal] = useState(false);
const [loadingDecline, setLoadingDecline] = useState(false);

const [showDeleteModal, setShowDeleteModal] = useState(false);
const [showAcceptModal, setShowAcceptModal] = useState(false);
const [courseToDelete, setCourseToDelete] = useState(null);

const [showAssignModal, setShowAssignModal] = useState(false);
const [courseToAssign, setCourseToAssign] = useState(null);
const [selectedStaff, setSelectedStaff] = useState([]);

const [allCoursesData, setAllCoursesData] = useState();
const [allCourseLoading, setAllCourseLoading] = useState(false);
const [assignStaffLoading, setAssignStaffLoading] = useState(false);

const [searchedCourses, setSearchedCourses] = useState([]);
const [isSearching, setIsSearching] = useState(false);
const [searchTerm, setSearchTerm] = useState('');

const [cachedPages, setCachedPages] = useState({});
const [totalPages, setTotalPages] = useState(1);
const [currentPage, setCurrentPage] = useState(1);

const [loadingAccept, setLoadingAccept] = useState(false);
const [loadingDelete, setLoadingDelete] = useState(false);
const [cardData, setCardData] = useState();





 const handleSearch = () => {
    if (!searchTerm.trim()) return;
    setIsSearching(true);
    console.log("searchTermsearchTerm", searchTerm)
    fetchCourseData(1, searchTerm);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  const clearSearch = () => {
    setSearchTerm('');
    setSearchedCourses([]);
    setIsSearching(false);
    fetchCourseData(1);
  };


  const [allStaffData, setAllStaffData] = useState(null);

const fetchCourseData = async (page = 1, search = '') => {
    setAllCourseLoading(true);

    // Check cache if not searching
    if (!search && cachedPages[page]) {
      setAllCoursesData(cachedPages[page]);
      setCurrentPage(page);
      setAllCourseLoading(false);
      return;
    }

    try {
      const data = await getAllTrainerManagement({ page, search });
     console.log("akjsfjksadf",data)
      if (data?.data) {
        setAllCoursesData(data.data);
        setCurrentPage(page);
        setTotalPages(data.totalPages || 1);

        if (!search) {
          setCachedPages(prev => ({
            ...prev,
            [page]: data.data
          }));
        }
      }
       if(data){
        const cards = [
      {
        title: "Total Managers",
        logo1: logo1,
        logo2: totalCoursesIcon,
        count: data.totalTrainers?.toString() || "0",
      },
      {
        title: "Approved Managers",
        logo1: green,
        logo2: userIcon,
        count: data.approvedTrainers?.toString() || "0",
      },
      {
        title: "Awaiting Approved",
        logo1: blue,
        logo2: trainerhatIcon,
        count: data.awaitingTrainers?.toString() || "0",
      },
    ];
    setCardData(cards)

      }
    } catch (error) {
      console.error("Failed to fetch courses:", error);
    } finally {
      setAllCourseLoading(false);
    }
  };





  // const fetchData = async () => {
  //   const data = await getAllStaff();
  //   if (data) {
  //     console.log("Staff data >>>", data);
  //     setAllStaffData(data.staffs);
  //   }
  // };

  // useEffect(() => {
  //   fetchData();
  // }, []);

  // const fetchCourseData = async () => {
    
  //   // setAllCourseLoading(true)
  //   // let data = await getAllCourses();
  //   // if (data) {
  //   //   console.log("data>>>", data)
  //   //   setAllCoursesData(data?.data)
  //   // }
  //   // setAllCourseLoading(false)

  // }
  useEffect(() => {
    //  fetchCourseData()
    fetchCourseData(1)
  }, [])


  useEffect(() => {
    // Check localStorage for any new courses
    // const storedCourses = localStorage.getItem('courses');
    // if (storedCourses) {
    //   setCourses(JSON.parse(storedCourses));
    // }

    // Check if we have a newly added course to show details for
    // const newAddedCourse = localStorage.getItem('addedCourse');
    // if (newAddedCourse) {
    //   setAddedCourse(JSON.parse(newAddedCourse));
    //   setIsDetailsModalOpen(true);
    //   // Clear the stored course after showing it
    //   localStorage.removeItem('addedCourse');
    // }
  }, []);

   const handleConfirmAccept = async () => {
      setLoadingAccept(true)
      const response = await acceptTrainerByAdmin(courseToDelete)
      console.log("resoponse>>", response)
      
      if(response?.success){
        const updatedCourses = allCoursesData.map(course =>
        course._id === courseToDelete
          ? { ...course, isApproved: true }
          : course
      );
      setAllCoursesData(updatedCourses);
        toast.success(response?.message)
      }
      setLoadingAccept(false)
      setShowAcceptModal(false);
      // toast.success("Course deleted successfully!");
    };


  const handleDeclineClick = (id) => {
    setCourseToDelete(id);
    setShowDeleteModal(true);
  };
   const handleDeclineTrainerClick = (id) => {
    setCourseToDelete(id);
    setShowDeclineTrainerModal(true);
  };

  const handleAcceptClick = (id) => {
    setCourseToDelete(id);
    setShowAcceptModal(true);
  };

  const handleDeleteClick = (id) => {
    setCourseToDelete(id);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    const response = await deleteTrainerByAdmin(courseToDelete)
    console.log("resoponse>>", response)
  
    if (response?.success) {
        const updatedCourses = allCoursesData.filter(course => course._id !== courseToDelete);
    setAllCoursesData(updatedCourses);
      toast.success(response?.message)
    }
    setShowDeleteModal(false);
    // toast.success("Course deleted successfully!");
  };

   const handleConfirmDecline = async () => {
    setLoadingDecline(true)
    const response = await declineTrainerByAdmin(courseToDelete)
    console.log("resoponse>>", response)
  
   if(response?.success){
        const updatedCourses = allCoursesData.map(course =>
        course._id === courseToDelete
          ? { ...course, isApproved: false }
          : course
      );
      setAllCoursesData(updatedCourses);
        toast.success(response?.message)
      }
      setLoadingDecline(false)
      setShowDeclineTrainerModal(false);
    
    // toast.success("Course deleted successfully!");
  };

  const handleAssignClick = (id) => {
    setCourseToAssign(id);
    setShowAssignModal(true);
    setSelectedStaff([]);
  };

  const handleStaffSelection = (staffId) => {
    if (selectedStaff.includes(staffId)) {
      setSelectedStaff(selectedStaff.filter(id => id !== staffId));
    } else {
      setSelectedStaff([...selectedStaff, staffId]);
    }
  };

  const handleAssignSubmit = async () => {
    console.log(`Assigning staff `, selectedStaff);
    setAssignStaffLoading(true)
    const data = {
      courseId: courseToAssign,
      staffIds: selectedStaff
    }

    const response = await assignStaff(data)
    console.log("response>>>>>", response)
    if (response.success) {
      toast.success(response.message)
    }
    // This would normally be an API call
    // toast.success("Staff assigned successfully!");
    setAssignStaffLoading(false)
    setShowAssignModal(false);
  };

  useEffect(() => {
  const delayDebounce = setTimeout(() => {
    if (searchTerm.trim()) {
      handleSearch();
    }
  }, 300); 

  return () => clearTimeout(delayDebounce); 
}, [searchTerm]);

  return (
    <div className="container " style={{padding:'0px 30px'}}>
      {/* Main Content */}
      <div className="row align-items-center mb-4 gx-3 my-4">
        <div className="col">
          <div className="search-container position-relative">
            <i
              className="bi bi-search position-absolute search-icon"
              style={{ cursor: 'pointer' }}
              // onClick={handleSearch}
            ></i>

            <input
              type="text"
              className="search-input w-100"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              // onKeyDown={handleKeyPress}
            />

            {isSearching && (
              <i
                className="bi bi-x-lg position-absolute"
                style={{
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  color: '#999',
                }}
                onClick={clearSearch}
              ></i>
            )}
          </div>
        </div>
        <div className="col-auto">
          <div className="d-flex align-items-center gap-3">
            {/* <button className="btn btn-light filter-btn">
              <i className="bi bi-funnel"></i>
            </button> */}
            {/* <button className="btn btn-light notification-btn position-relative">
              <i className="bi bi-bell"></i>
              <span className="notification-badge position-absolute"></span>
            </button> */}
              <NotificationsDropdown />

          </div>
        </div>


      </div>
      <div class="row pb-5">
         {
          cardData && cardData?.map((item) => {
            return (
              <Card col="4" Title={item.title} logo1={item.logo1} logo2={item.logo2} count={item?.count} />
            )
          })
        }
      </div>
      {/* {
        allCourseLoading ?

          <div className="col-md-12" style={{ height: '40vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div class="spinner-border spinner-border-sm" role="status"></div>
          </div>
          :
          <CourseTable
            courses={isSearching ? searchedCourses : allCoursesData}
            onDeleteCourse={handleDeleteClick}
            onAssignStaff={handleAssignClick}
          />
      } */}
      {
        allCourseLoading ?

          <div className="col-md-12" style={{ height: '40vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div class="spinner-border spinner-border-sm" role="status"></div>
          </div>
          :
          <>

            <CourseTable
              courses={allCoursesData}
              setCourses={setAllCoursesData}
              onDeclinePolicy={handleDeclineClick}
              onAssignStaff={handleAssignClick}
              onAccept={handleAcceptClick}
              onDeclineTrainer={handleDeclineTrainerClick}

            />


            <nav className="d-flex justify-content-center mt-4">
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button
                    className="page-link d-flex align-items-center justify-content-center"
                    onClick={() => fetchCourseData(currentPage - 1, isSearching ? searchTerm : '')}
                    disabled={currentPage === 1}
                  >
                    <i className="bi bi-chevron-left"></i>
                  </button>
                </li>

                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                    <button
                      className="page-link"
                      onClick={() => fetchCourseData(page, isSearching ? searchTerm : '')}
                    >
                      {page}
                    </button>
                  </li>
                ))}

                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <button
                    className="page-link d-flex align-items-center justify-content-center"
                    onClick={() => fetchCourseData(currentPage + 1, isSearching ? searchTerm : '')}
                    disabled={currentPage === totalPages}
                  >
                    <i className="bi bi-chevron-right"></i>
                  </button>
                </li>
              </ul>
            </nav>
          </>
      }


      {/* Course Details Modal */}
      {isDetailsModalOpen && addedCourse && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content border-0 bg-transparent shadow-none">
              <div className="modal-body p-0">
                <CourseDetails
                  course={addedCourse}
                  onClose={() => setIsDetailsModalOpen(false)}
                />
              </div>
            </div>
          </div>
          <div className="modal-backdrop show"></div>
        </div>
      )}
{showDeclineTrainerModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button type="button" className="btn-close" onClick={() => setShowDeclineTrainerModal(false)}></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to Decline this Manager?</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowDeclineTrainerModal(false)}>
                  Cancel
                </button>
                <button type="button" disabled={loadingDecline} className="btn btn-danger" onClick={handleConfirmDecline}>
                 {
                  loadingDecline ? "loading..." :"Accept"
                 } 
                </button>
              </div>
            </div>
          </div>
          {/* <div className="modal-backdrop show"></div> */}
        </div>
      )}
      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button type="button" className="btn-close" onClick={() => setShowDeleteModal(false)}></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this Manager?</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>
                  Cancel
                </button>
                <button type="button" className="btn btn-danger" onClick={handleConfirmDelete}>
                  Delete
                </button>
              </div>
            </div>
          </div>
          {/* <div className="modal-backdrop show"></div> */}
        </div>
      )}
 {showAcceptModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirmation</h5>
                <button type="button" className="btn-close" onClick={() => setShowAcceptModal(false)}></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to Accept this Manager?</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowAcceptModal(false)}>
                  Cancel
                </button>
                <button type="button" className="btn btn-success" onClick={handleConfirmAccept} disabled={loadingAccept}>
                 {
                  loadingAccept ? "loading..." :"Accept"
                 } 
                </button>
              </div>
            </div>
          </div>
          {/* <div className="modal-backdrop show"></div> */}
        </div>
      )}
      {/* Assign Staff Modal */}
      {showAssignModal && (
        <>
          {
            console.log("allStaffDataallStaffData", allStaffData)
          }
          <div className="modal show d-block" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Assign Staff Members</h5>
                  <button type="button" className="btn-close" onClick={() => setShowAssignModal(false)}></button>
                </div>
                <div className="modal-body">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Role</th>
                        <th>Select</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allStaffData && allStaffData.map(staff => {
                        return (
                          <tr key={staff._id}>
                            <td>{staff.fullName}</td>
                            <td>{staff.username}</td>
                            <td>{staff.role}</td>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={selectedStaff.includes(staff._id)}
                                  onChange={() => handleStaffSelection(staff._id)}
                                />
                              </div>
                            </td>
                          </tr>
                        )

                      })}
                    </tbody>
                  </table>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowAssignModal(false)}>
                    Cancel
                  </button>
                  <button
                    type="button"
                    className=" text-white btn-custom"
                    onClick={handleAssignSubmit}
                    disabled={selectedStaff.length === 0 || assignStaffLoading}
                  >
                    {
                      assignStaffLoading ?
                        "loading....."
                        :
                        "Assign Selected Staff"
                    }

                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Backdrop */}
          {/* <div className="modal-backdrop show"></div> */}
        </>
      )}
    </div>
  );
};

export default TrainerManagement;